import { Flex, Typography } from 'antd'

import './styles.scss'

const { Title } = Typography
type HeaderContentProps = {
  title: string
  description: string
  breadcrumbSlot?: React.ReactNode
  buttonSlot?: React.ReactNode
}

export const HeaderContent = ({
  title,
  description,
  breadcrumbSlot,
  buttonSlot,
}: HeaderContentProps) => {
  return (
    <Flex component="section" className="header-content" gap={12} vertical>
      {breadcrumbSlot}
      <Flex justify="space-between" align="center" gap={12}>
        <Flex gap={8} vertical className="header-content__info">
          <Title level={4} style={{ margin: 0 }}>
            {title}
          </Title>
          <p className="header-content__description">{description}</p>
        </Flex>
        {buttonSlot}
      </Flex>
    </Flex>
  )
}
